import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useFormState } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';

import CommonDropdown from '../../../../../components/common-dropdown/CommonDropdown';
import CommonSwitch from '../../../../../components/common-switch/CommonSwitch';
import useCompetitorOptions from '../../../../../hooks/useCompetitorOptions';
import MultiselectDropdownNew from '../../../../../components/multiselect-dropdown/MultiselectDropdownNew';
import { addNewGroupOption } from '../../../../../redux/create-sonar/createSonarReducer';
import FieldWrapper from './FieldWrapper';

import scss from '../SonarDatasetModal.module.scss';

const ProjectSettingsSection = () => {
  const { t } = useTranslation('projects');
  const dispatch = useDispatch();

  const competitorOptions = useCompetitorOptions();
  const groupsOptions = useSelector((state) => state.createSonar.groupsOptions);
  const isEditableDatasetLoading = useSelector((state) => state.sonarManagement.isEditableDatasetLoading);
  const { submitting } = useFormState();

  const disableFields = isEditableDatasetLoading || submitting;

  const handleAddNewGroupOption = useCallback(
    (option) => {
      dispatch(addNewGroupOption(option));
    },
    [dispatch],
  );

  return (
    <div className={scss.formSectionContent}>
      <Field name='competitorType'>
        {({ input, meta }) => (
          <FieldWrapper label={t('competitor')} isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
            <CommonDropdown
              value={input.value}
              options={competitorOptions}
              onSelect={input.onChange}
              name={input.name}
              onBlur={input.onBlur}
              onFocus={input.onFocus}
              isError={meta.touched && meta.error}
              disabled={disableFields}
            />
          </FieldWrapper>
        )}
      </Field>

      <FieldWrapper label={t('inEcosystem')}>
        <Field name='inEcosystem' type='checkbox'>
          {({ input }) => <CommonSwitch {...input} disabled={disableFields} />}
        </Field>
      </FieldWrapper>

      <FieldWrapper label={t('inFocus')}>
        <Field name='inFocus' type='checkbox'>
          {({ input }) => <CommonSwitch {...input} disabled={disableFields} />}
        </Field>
      </FieldWrapper>

      <FieldWrapper label={t('myCompany')}>
        <Field name='myCompany' type='checkbox'>
          {({ input }) => <CommonSwitch {...input} disabled={disableFields} />}
        </Field>
      </FieldWrapper>

      <Field name='groups'>
        {({ input, meta }) => (
          <FieldWrapper label={t('groups')} isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
            <MultiselectDropdownNew
              value={input.value}
              options={groupsOptions}
              onChange={input.onChange}
              name={input.name}
              onBlur={input.onBlur}
              onFocus={input.onFocus}
              isError={meta.touched && meta.error}
              onAddNewOption={handleAddNewGroupOption}
              disabled={disableFields}
            />
          </FieldWrapper>
        )}
      </Field>
    </div>
  );
};

export default memo(ProjectSettingsSection);
